// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2X6-z","header":"ClearentDisclaimer_header__1uP9F","inner":"ClearentDisclaimer_inner__YamqM"};